import dayjs from 'dayjs';
import 'dayjs/locale/pt';
import utc from 'dayjs/plugin/utc';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';

import pt from 'dayjs/locale/pt';

// Carregar locale português
dayjs.locale(pt);
// Registar variações para que o Day.js encontre sempre a configuração correta,
// independentemente da caixa usada em MAT_DATE_LOCALE (pt, pt-pt, pt-PT)
dayjs.locale('pt-pt', pt);
dayjs.locale('pt-PT', pt);

// Estender dayjs com plugins necessários
dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);

// Configurar formatos padrão para português (unificar pt e pt-pt)
const ptLocaleConfig = {
  formats: {
    L: 'DD-MM-YYYY',
    LL: 'D [de] MMMM [de] YYYY',
  },
};

dayjs.updateLocale('pt', ptLocaleConfig);
dayjs.updateLocale('pt-pt', ptLocaleConfig);
dayjs.updateLocale('pt-PT', ptLocaleConfig);

// Definir locale global padrão
dayjs.locale('pt');

// Resolver problema de offset de timezones (bug de um dia de diferença):
// O Angular converte os payloads usando JSON.stringify.
// O JSON.stringify chama internamente o método .toJSON() do objeto Dayjs.
// O .toJSON() original do dayjs emite a data em UTC (subtraindo horas e mudando de dia no Verão).
// Ao reescrever este método globalmente, forçamos o envio da data local real escolhida pelo utilizador.
const dayjsPrototype = (dayjs as any).prototype || Object.getPrototypeOf(dayjs());
dayjsPrototype.toJSON = function () {
  return this.format('YYYY-MM-DDTHH:mm:ss');
};

export default dayjs;
